<ion-content>
  <main class="page-container page-container--text-content">
    <h1 class="title">Die Seite wurde nicht gefunden (404)</h1>

    <p>Ihre angeforderte Seite existiert leider nicht.</p>
    <p>Ein möglicher Grund dafür könnte ein Tippfehler in Ihrem Link sein.</p>
    <p>Oder die Seite existiert nicht mehr, etwa weil ein gesuchtes Programm bereits vorbei ist.</p>

    <app-button [routerLink]="['/']">Zur Homepage</app-button>
  </main>

<app-footer></app-footer>
</ion-content>
